/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Fact.
 */
export interface DemandFactLastmile { 
    /**
     * Fact type.
     */
    type: DemandFactLastmileTypeEnum;
    /**
     * Fact time in the [RFC 3339, section 5.6 (ISO8601)](https://tools.ietf.org/html/rfc3339#section-5.6) format.
     */
    time: string;
    /**
     * Demand key.
     */
    demand_key: string;
}
export enum DemandFactLastmileTypeEnum {
    DONE = 'DONE',
    CANCEL = 'CANCEL'
};



